module.exports = __webpack_public_path__ + "static/media/landing_angler.8ff4bf04.jpg";